import { writable } from 'svelte/store';

/*
* To open or close, use the sidebarOpenStore with a payload of {id: 'sidebarId', isOpen: true, data: {}}
 */
export const sidebarOpenStore = writable({id: null, isOpen: false, data: {}});
